import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginModal from './LoginModal';
import '../styles/components/Header.css';

function Header() {
	const navigate = useNavigate();

	// 메인 홈페이지로 이동
	const handleGoHome = () => {
		navigate('/');
	};
  
	const goGuide = () => {
		window.open('/guide', '_blank', 'noopener,noreferrer');
	};

	const askLogin = () => {
		alert('문의하기는 로그인 후 이용 가능합니다.');
	};

	// 공지사항 이동 (로그인 불필요)
	const goNotice = () => {
		navigate('/notice');
	};

	// 자주 묻는 질문(FAQ) 이동 (로그인 불필요)
	const goFaq = () => {
		navigate('/faq');
	};

	// 광고대행 문의하기 이동
	const goContact = () => {
		navigate('/contact');
	};

	// 타깃별 전용 랜딩(LP) 이동 (로그인 불필요)
	const goMarketerLp = () => {
		navigate('/lp/marketer');
	};
	const goInfluencerLp = () => {
		navigate('/lp/influencer');
	};

	//로그인/회원가입 모달 버튼 제어
	const [modalOpen, setModalOpen] = useState(false);
	const handleOpenModal = () => {
		setModalOpen(true);
	};
	const handleCloseModal = () => {
		setModalOpen(false);
	};

	return (
		<header className="public-header">
			<div className="public-header__left">
				<button className="public-header__logo-button" onClick={handleGoHome} aria-label="홈페이지">
					<img 
						src="/images/logo.svg" 
						alt="셀프애드" 
						className="public-header__logo"
					/>
				</button>
				<button className="public-header__nav-button" onClick={goMarketerLp}>광고주 안내</button>
				<button className="public-header__nav-button" onClick={goInfluencerLp}>인플루언서 안내</button>
				<button className="public-header__nav-button" onClick={goGuide}>서비스 가이드</button>
				<button className="public-header__nav-button" onClick={goNotice}>공지사항</button>
				<button className="public-header__nav-button" onClick={goFaq}>FAQ</button>
				<button className="public-header__nav-button" onClick={askLogin}>문의하기</button>
				<button className="public-header__nav-button" onClick={goContact}>광고대행 요청</button>
			</div>
			
			<div className="public-header__right">
				<button className="public-header__cta-button" onClick={handleOpenModal}>
					로그인 / 회원가입
				</button>
			</div>
			{modalOpen && <LoginModal onClose={handleCloseModal} />}
		</header>
	);
}

export default Header;